import React, { useEffect, useState } from "react";
import {
  getTipoDocumentos,
  postTipoDocumentos,
  putTipoDocumentos,
  //deleteTipoDocumentos,
} from "../../componentes/http/actions/TipoDocumentoAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import NuevoTipoDocumentoModal from "../../componentes/modal/TipoDocumento/NuevoTipoDocumentoModal";
import EditarTipoDocumentoModal from "../../componentes/modal/TipoDocumento/EditarTipoDocumentoModal";
import FilterComponent from "../../componentes/data/FilterComponent";
const GestorTipoDocumento = () => {
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchTipoDocumentos();
  }, []);

  const fetchTipoDocumentos = () => {
    setIsLoading(true);
    getTipoDocumentos(localStorage.getItem("token"))
      .then((response) => {
        setTipoDocumentos(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredDocumentos = tipoDocumentos
    .filter((documento) => {
      const matchesSearch = documento.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && documento.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          documento.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  //Modal de nuevo tipo de documento
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //Modal de editar tipo de documento
  const handleOpenEditModal = (documento) => {
    setDocumentoSeleccionado(documento);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setDocumentoSeleccionado(null);
  };

  const handleNuevoTipoDocumento = async (nuevoTipo) => {
    try {
      setIsLoading(true);
      await postTipoDocumentos(localStorage.getItem("token"), nuevoTipo);
      await fetchTipoDocumentos();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Tipo de documento agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo tipo de documento:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar tipo de documento: tipo ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarTipoDocumento = async (documentoEditado) => {
    try {
      setIsLoading(true);
      await putTipoDocumentos(localStorage.getItem("token"), documentoEditado);
      await fetchTipoDocumentos();
      setSnackbar({
        open: true,
        message: "Tipo de documento editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar tipo de documento:", error);
      setSnackbar({
        open: true,
        message: "Error al editar tipo de documento: tipo ya existe o error en el servidor",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ 
        width: '100%', 
      }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron tipos de documentos con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Tipo de Documentos</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir tipo de documento
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : filteredDocumentos.length > 0 ? (
          <>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Habilitado</TableCell>
                <TableCell sx={{ display: "flex", justifyContent: "center" }}>
                  Acciones{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDocumentos.map((documento, index) => (
                <TableRow key={index}>
                  <TableCell>{documento.id}</TableCell>
                  <TableCell>{documento.nombre}</TableCell>
                  <TableCell>
                    <Chip
                      label={documento.habilitado ? "Sí" : "No"}
                      color={documento.habilitado ? "success" : "error"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                      <Tooltip title="Editar tipo de documento">
                        <Button
                          size="small"
                          color="primary"
                          sx={{ mr: 1 }}
                          onClick={() => handleOpenEditModal(documento)}
                        >
                          <EditNoteIcon />
                        </Button>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={
            tipoDocumentos.filter((documento) => {
              const matchesSearch = documento.nombre
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
              const matchesFilter =
                filterHabilitado === "todos" ||
                (filterHabilitado === "habilitado" &&
                  documento.habilitado === true) ||
                (filterHabilitado === "deshabilitado" &&
                  documento.habilitado === false);
              return matchesSearch && matchesFilter;
            }).length
          }
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>
      <NuevoTipoDocumentoModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoTipoDocumento}
        isLoading={isLoading}
      />
      <EditarTipoDocumentoModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarTipoDocumento}
        documento={documentoSeleccionado}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorTipoDocumento;
